$(->
  # TODO: brittany 10/4 - Stale? CSRF meta tags are added in our application layout (see cplook). Code is 4 years old

  $('form.add_csrf').each ->
    csrf_token = $('meta[name=csrf-token]').attr('content')
    csrf_param = $('meta[name=csrf-param]').attr('content')
    if csrf_param != undefined && csrf_token != undefined
      $(this).append('<input name="' + csrf_param + '" value="' + csrf_token + '" type="hidden" />')

)
